import type { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Icon } from '../../../src/components/atoms/Icon';

import styles from './index.module.scss';

export const renderComparisonCardContentOptions: Options = {
  renderNode: {
    [BLOCKS.UL_LIST]: (text, children) => <ul className={styles.HelperUl}>{children}</ul>,
    [BLOCKS.LIST_ITEM]: (text, children) => (
      <li className={styles.HelperLi}>
        <Icon id="icon_checked_green" className={styles.HelperCheckIcon} /> {children}
      </li>
    ),
  },
};
